<template>
	<div class="vcx-grid">
		<div class="vcx-col-12 vcx-col-6-lg">
			<div class="vcx-performance__header">
				<h2 class="vcx-h4 vcx-text-inverse">Fundrise Innovation Fund (VCX)</h2>
			</div>
		</div>
		<div class="vcx-col-12 vcx-col-6-lg">
			<div class="vcx-performance__metrics" role="table" aria-label="Performance returns by period">
				<div v-for="metric in displayMetrics" :key="metric.key" class="vcx-performance__metric" role="row">
					<div
						class="vcx-body-md vcx-text-gray-30 vcx-mb-50"
						role="rowheader"
						v-html="deorphanText(metric.key)"
					></div>
					<div class="vcx-h5 vcx-text-inverse" role="cell">
						<BasePlaceHolderInline :placehold="isLoading" theme="dark" width="4rem">{{
							metric.value
						}}</BasePlaceHolderInline>
					</div>
				</div>
			</div>
		</div>
		<div class="vcx-col-12 vcx-col-5-lg">
			<BasePlaceHolder :placehold="isLoading" theme="dark" :line-count="2">
				<p class="vcx-body-sm vcx-text-gray-40 vcx-mt-50 vcx-font-style-italic">{{ performanceDisclaimer }}</p>
			</BasePlaceHolder>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { deorphanText } from '@filters/shared-filters';
import { SanityKeyValueData } from 'types/sanity/charts-data';

interface Props {
	isLoading?: boolean;
	performanceMetrics: Array<SanityKeyValueData>;
	performanceDisclaimer: string;
}

const props = withDefaults(defineProps<Props>(), {
	isLoading: false
});

const displayMetrics = computed(() => {
	if (props.isLoading) {
		return [
			{ key: '3 months', value: '' },
			{ key: 'YTD', value: '' },
			{ key: '1 year', value: '' },
			{ key: 'Since inception', value: '' }
		];
	}
	return props.performanceMetrics;
});
</script>

<style scoped lang="scss">
@use '../../styles/vcx/responsive' as *;
.vcx-performance {
	width: 100%;

	&__header {
		margin-bottom: var(--vcx-space-200);
	}

	@include vcx-media-md {
		&__header {
			margin-bottom: 0;
		}
	}

	&__metrics {
		display: grid;
		grid-template-columns: 1fr;

		@include vcx-media-md {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
		}
	}

	&__metric {
		display: grid;
		grid-template-columns: 1fr auto;
		gap: var(--vcx-space-25);

		&:not(:last-child) {
			padding-bottom: var(--vcx-space-150);
		}

		@include vcx-media-md {
			display: flex;
			flex-direction: column;
			padding: 0 var(--vcx-space-150);
			border-bottom: none;
			border-left: 1px solid var(--vcx-border-dark-medium);

			&:first-child {
				border-left: none;
				padding-left: 0;
			}

			&:last-child {
				padding-right: 0;
			}

			&:not(:last-child) {
				padding-bottom: unset;
			}
		}
	}
}
</style>
